import React,{Component} from 'react';

export default class AboutComponent extends Component {
    render() {
      return (    
        <div className="AboutContainer" id="About">
      <h1>
        <span className='white'>About</span> MOHD ROHAAN</h1>
      
      <img src={require('./images/profile.JPG')} className="rounded-circle" alt="profile" />
      <br/>
      
      <p>A few interesting things about me. I love to read Detective fiction (my favorite is Sherlock Holmes). I am also an avid gamer. I love to play competitive strategy games and first-person shooters like CSGO and PUBG. You can also add me on SOCIALCLUB - @NinjaHatodi (My gaming name) Lastly, I love learning. Every day I push myself to learn something new, whether that be about machine learning, software engineering, or miscellaneous facts about the universe. 
         A web developer designs, develops, enhances, tests and deploys web applications with an end goal of creating engaging and user-friendly site layout and function. A developer gathers and defines requirements, maintains websites, troubleshoots and fixes bugs, follows best practices and collaborates with other teams.
      </p>
  </div>

      )
    }
  }

